import { cn } from '../lib/utils';

function Card({ className, dataTestId, ...props }) {
  return (
    <div
      data-slot="card"
      data-testid={dataTestId}
      className={cn('bg-card text-card-foreground rounded-xl border shadow-sm', className)}
      {...props}
    />
  );
}

function CardHeader({ className, dataTestId, ...props }) {
  return (
    <div
      data-slot="card-header"
      data-testid={dataTestId}
      className={cn('flex flex-col gap-1.5 p-6', className)}
      {...props}
    />
  );
}

function CardTitle({ className, dataTestId, ...props }) {
  return (
    <div data-slot="card-title" data-testid={dataTestId} className={cn('leading-none font-semibold', className)} {...props} />
  );
}

function CardDescription({ className, dataTestId, ...props }) {
  return (
    <div
      data-slot="card-description"
      data-testid={dataTestId}
      className={cn('text-muted-foreground text-sm', className)}
      {...props}
    />
  );
}

function CardContent({ className, dataTestId, ...props }) {
  return <div data-slot="card-content" data-testid={dataTestId} className={cn('p-6 pt-0', className)} {...props} />;
}

function CardFooter({ className, dataTestId, ...props }) {
  return (
    <div
      data-slot="card-footer"
      data-testid={dataTestId}
      className={cn('flex items-center p-6 pt-0', className)}
      {...props}
    />
  );
}

export { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle };
